import {
    START_TRIAL_REQUEST,
    START_TRIAL_SUCCESS,
    START_TRIAL_FAILURE,
    START_TRIAL_RESET
} from "./TrialTypes";

const initialState = {
    loading: false,
    data: null,
    error: null,
    success: false
};

const trialReducer = (state = initialState, action) => {
    switch (action.type) {
        case START_TRIAL_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                success: false
            };
        case START_TRIAL_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
                success: true
            };
        case START_TRIAL_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false
            };
        case START_TRIAL_RESET:
            return initialState;
        default:
            return state;
    }
};

export default trialReducer;
